// Identifies which app-store platform a device receipt comes from. The
// string values match the wire format used by the cdvPurchase library
// and the refauth /receipt-validator + /lookup-username-by-receipt
// endpoints, so they MUST stay as the literal strings exactly as
// written. Server-side (refauth, JS-only) accepts the same strings —
// keep this enum in sync with those checks if/when the format changes.
export enum StoreReceiptPlatform {
    APPLE_APPSTORE = "ios-appstore",
    GOOGLE_PLAY = "android-playstore",
}
